/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import client from 'client';
import BookingActionTypes from '../types/booking';

export const fetchConfiguration = () => async (dispatch, getState) => {
  const { loading } = getState();
  if (loading) return;
  try {
    await dispatch({
      type: BookingActionTypes.LOAD_CONFIGURATION_REQUEST,
    });

    const { data } = await client.get('/apis/v2/online_bookings/configurations');

    const publishedData = data?.data?.attributes?.publishedData;
    await dispatch({
      type: BookingActionTypes.LOAD_CONFIGURATION_SUCCESS,
      payload: { data: Object.keys(publishedData).length === 0 ? null : publishedData },
    });
  } catch (error) {
    await dispatch({
      type: BookingActionTypes.LOAD_CONFIGURATION_FAILURE,
      error,
    });
  }
};
